export const validateContext = (context, {
  contextName = 'Context',
  providerName = 'provider'
} = {}) => {
  if (context === undefined) {
    throw new Error(`${contextName} must be used within a ${providerName}`)
  }

  return context
}
